// import { useState } from "react";
// import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Avatar, useMediaQuery, Modal, IconButton } from "@mui/material";
// import { motion } from "framer-motion";
// import CloseIcon from "@mui/icons-material/Close";

// const headings = [
//   { title: "Research Design Strategy", subheading: "Crafting a Strong Research Framework", content: "We help you choose the most suitable research design, ensuring clarity and alignment with your study's objectives.", points: ["Identify the best research paradigm (qualitative, quantitative, or mixed-methods)", "Define clear research questions and hypotheses.", "Select appropriate data collection techniques.", "Ensure reliability and validity of the study.", "Structure a well-defined research framework."]},
//   { title: "Qualitative Research Approach", subheading: "Exploring In-depth Insights", content: "Our experts guide you in designing qualitative research that captures rich, detailed insights through various methods.", points: ["Choose suitable qualitative methods (interviews, focus groups, case studies).", "Develop effective open-ended research questions.", "Ensure ethical considerations in qualitative studies.", "Use thematic analysis or grounded theory for interpretation.", "Enhance credibility with triangulation techniques."] },
//   { title: " Quantitative Research Approach", subheading: "Data-Driven Analysis & Findings", content: "We assist in structuring a quantitative methodology with precise statistical tools for valid and reliable results.", points: ["Select the appropriate sampling technique.", "Define key variables and measurement scales.", "Choose statistical tests (ANOVA, regression, t-tests).", "Ensure data accuracy and consistency.", "Interpret results using statistical software (SPSS, R, Python)."] },
//   { title: "Mixed-Methods Research", subheading: "Integrating Qualitative & Quantitative Approaches", content: "Get expert guidance on combining both research paradigms for a well-rounded study.", points: ["Design a balanced research methodology.", "Integrate qualitative and quantitative data effectively.", "Address challenges of mixed-method designs.", "Ensure coherence between different data sources.", "Interpret findings with a comprehensive approach."] },
//   { title: "Data Collection Techniques", subheading: "Choosing the Right Methods for Reliable Data", content: "We assist in selecting the most effective data collection strategies tailored to your research objectives.", points: ["Choose between primary and secondary data collection.", "Design surveys, questionnaires, or interview guides.", "Ensure unbiased and ethical data collection.", "Select suitable sampling techniques.", "Address potential limitations in data gathering."] },
//   { title: "Sampling Methods & Techniques", subheading: "Selecting the Right Participants for Your Study", content: "Our guidance ensures you pick the best sampling method for accurate and meaningful results.", points: ["Differentiate between probability and non-probability sampling.", "Determine the ideal sample size.", "Reduce bias in participant selection.", "Justify your sampling method in the methodology section.", "Align sampling with research objectives."] },
//   { title: "Data Analysis & Interpretation", subheading: "Making Sense of Your Research Data", content: "We provide guidance on analyzing and interpreting data accurately to derive meaningful conclusions.", points: ["Choose appropriate data analysis methods.", "Use statistical or thematic analysis based on methodology.", "Interpret results effectively with supporting evidence.", "Visualize data with charts, graphs, and tables.", "Draw logical and valid conclusions."] },
//   { title: "Validity, Reliability & Ethical Considerations", subheading: "Ensuring Credibility & Ethical Standards", content: "We guide you in maintaining high academic standards with ethical and reliable research practices.", points: ["Differentiate between validity and reliability.", "Use pilot studies to test research instruments.", "Follow ethical guidelines (informed consent, confidentiality).", "Minimize biases in data collection and analysis.", "Justify ethical considerations in your dissertation."] },
// ];

// export default function ServicePage() {
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const [open, setOpen] = useState(false);
//   const isSmallScreen = useMediaQuery("(max-width: 900px)");

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         p: 3,
//         width: "100vw",
//         minHeight: "100vh",
//         overflow: "hidden",
//         bgcolor: "#f5f5f5",
//       }}
//     >
//       <Typography
//         variant="h4"
//         fontWeight={600}
//         gutterBottom
//         textAlign="center"
//         color="#172554"
//         sx={{ 
//           fontSize: { xs: "22px", sm: "26px", md: "30px" },
//           letterSpacing: "0.5px",
//           mb: 3
//         }}
//       >
//         Guidance{" "}
//         <span
//           style={{
//             background:
//               "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
//             padding: "0px 5px",
//             borderRadius: "4px"
//           }}
//         >
//           for Research 
//         </span>{" "}
//         Excellence
//       </Typography>
      
//       {/* Main Content */}
//       <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, width: "100%", flexGrow: 1, gap: 2 }}>
//         {/* Left Sidebar - Headings */}
//         <Box sx={{ 
//           flex: 1, 
//           backgroundColor: "#172554", 
//           color: "white", 
//           p: 2, 
//           borderRadius: "8px", 
//           display: "flex", 
//           flexDirection: "column", 
//           justifyContent: "center",
//           boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
//         }}>
//           <Typography 
//             variant="h5" 
//             fontWeight="bold" 
//             textAlign="center" 
//             mb={2}
//             sx={{ 
//               letterSpacing: "0.5px",
//               textTransform: "uppercase"
//             }}
//           >
//             Methodology Guidance
//           </Typography>
//           <List>
//             {headings.map((item, index) => (
//               <ListItem key={index} disablePadding>
//                 <ListItemButton
//                   selected={selectedIndex === index}
//                   onClick={() => {
//                     setSelectedIndex(index);
//                     if (isSmallScreen) setOpen(true);
//                   }}
//                   sx={{
//                     '&:hover': {
//                       backgroundColor: 'rgba(255,255,255,0.1)',
//                     },
//                     transition: 'background-color 0.3s ease'
//                   }}
//                 >
//                   <ListItemText 
//                     primary={item.title} 
//                     sx={{ 
//                       color: "white", 
//                       fontWeight: "bold",
//                       '& .MuiTypography-root': {
//                         fontWeight: 600,
//                         letterSpacing: '0.5px'
//                       }
//                     }} 
//                   />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         </Box>

//         {/* Right Content Section - Hidden in Small Screens */}
//         {!isSmallScreen && (
//           <Box sx={{ 
//             flex: 2, 
//             p: 3, 
//             backgroundColor: "#f3f4f6", 
//             color: "black", 
//             borderRadius: "8px", 
//             display: "flex", 
//             flexDirection: "column", 
//             alignItems: "center",
//             boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
//           }}>
//             <motion.div 
//               initial={{ opacity: 0 }} 
//               animate={{ opacity: 1 }} 
//               transition={{ duration: 0.5 }} 
//               style={{ width: "100%" }}
//             >
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <Avatar src="logo22.png" sx={{ width: 80, height: 80, mb: 2 }} />
//               </Box>

//               <Typography 
//                 variant="h5" 
//                 fontWeight="bold" 
//                 textAlign="center" 
//                 mb={1}
//                 sx={{ 
//                   letterSpacing: "0.5px",
//                   color: "#172554"
//                 }}
//               >
//                 {headings[selectedIndex].title}
//               </Typography>
//               <Typography 
//                 variant="subtitle1" 
//                 fontStyle="italic" 
//                 textAlign="center" 
//                 mb={2}
//                 sx={{ 
//                   color: "#4a5568",
//                   fontWeight: 500
//                 }}
//               >
//                 {headings[selectedIndex].subheading}
//               </Typography>
//               <Typography 
//                 textAlign="justify" 
//                 mb={3}
//                 sx={{ 
//                   lineHeight: 1.6,
//                   color: "#2d3748"
//                 }}
//               >
//                 {headings[selectedIndex].content}
//               </Typography>
//               <List sx={{ pl: { xs: 2, md: 4 }, width: "100%" }}>
//                 {headings[selectedIndex].points.map((point, i) => (
//                   <ListItem 
//                     key={i} 
//                     sx={{ 
//                       display: "list-item", 
//                       mb: 1,
//                       '& .MuiTypography-root': {
//                         textAlign: 'justify',
//                         lineHeight: 1.6
//                       }
//                     }}
//                   >
//                     <motion.div whileHover={{ scale: 1.05 }}>
//                       <Typography>{point}</Typography>
//                     </motion.div>
//                   </ListItem>
//                 ))}
//               </List>
//             </motion.div>
//           </Box>
//         )}
//       </Box>

//       {/* Modal for Small Screens */}
//       <Modal 
//         open={open} 
//         onClose={() => setOpen(false)} 
//         sx={{ 
//           display: "flex", 
//           alignItems: "center", 
//           justifyContent: "center" 
//         }}
//       >
//         <Box sx={{ 
//           bgcolor: "white", 
//           p: 3, 
//           borderRadius: 2, 
//           width: "90%", 
//           maxWidth: "400px", 
//           textAlign: "center", 
//           boxShadow: 24, 
//           position: "relative" 
//         }}>
//           {/* Close Button */}
//           <IconButton
//             onClick={() => setOpen(false)}
//             sx={{ 
//               position: "absolute", 
//               top: 8, 
//               right: 8, 
//               color: "#000" 
//             }}
//           >
//             <CloseIcon />
//           </IconButton>

//           {/* Modal Content */}
//           <Typography 
//             variant="h5" 
//             fontWeight="bold" 
//             mb={1}
//             sx={{ 
//               letterSpacing: "0.5px",
//               color: "#172554"
//             }}
//           >
//             {headings[selectedIndex].title}
//           </Typography>
//           <Typography 
//             variant="subtitle1" 
//             fontStyle="italic" 
//             mb={2}
//             sx={{ 
//               color: "#4a5568",
//               fontWeight: 500
//             }}
//           >
//             {headings[selectedIndex].subheading}
//           </Typography>
//           <Typography 
//             mb={2}
//             sx={{ 
//               textAlign: 'justify', 
//               lineHeight: 1.6,
//               color: "#2d3748"
//             }}
//           >
//             {headings[selectedIndex].content}
//           </Typography>
//           <List>
//             {headings[selectedIndex].points.map((point, i) => (
//               <ListItem 
//                 key={i} 
//                 sx={{ 
//                   display: "list-item", 
//                   mb: 1,
//                   '& .MuiTypography-root': {
//                     textAlign: 'justify',
//                     lineHeight: 1.6
//                   }
//                 }}
//               >
//                 <Typography>{point}</Typography>
//               </ListItem>
//             ))}
//           </List>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }





import { useState } from "react";
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Avatar, useMediaQuery, Modal, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";

const headings = [
  { title: "Research Design Strategy", subheading: "Crafting a Strong Research Framework", content: "We help you choose the most suitable research design, ensuring clarity and alignment with your study's objectives.", points: ["Identify the best research paradigm (qualitative, quantitative, or mixed-methods)", "Define clear research questions and hypotheses.", "Select appropriate data collection techniques.", "Ensure reliability and validity of the study.", "Structure a well-defined research framework."]},
  { title: "Qualitative Research Approach", subheading: "Exploring In-depth Insights", content: "Our experts guide you in designing qualitative research that captures rich, detailed insights through various methods.", points: ["Choose suitable qualitative methods (interviews, focus groups, case studies).", "Develop effective open-ended research questions.", "Ensure ethical considerations in qualitative studies.", "Use thematic analysis or grounded theory for interpretation.", "Enhance credibility with triangulation techniques."] },
  { title: " Quantitative Research Approach", subheading: "Data-Driven Analysis & Findings", content: "We assist in structuring a quantitative methodology with precise statistical tools for valid and reliable results.", points: ["Select the appropriate sampling technique.", "Define key variables and measurement scales.", "Choose statistical tests (ANOVA, regression, t-tests).", "Ensure data accuracy and consistency.", "Interpret results using statistical software (SPSS, R, Python)."] },
  { title: "Mixed-Methods Research", subheading: "Integrating Qualitative & Quantitative Approaches", content: "Get expert guidance on combining both research paradigms for a well-rounded study.", points: ["Design a balanced research methodology.", "Integrate qualitative and quantitative data effectively.", "Address challenges of mixed-method designs.", "Ensure coherence between different data sources.", "Interpret findings with a comprehensive approach."] },
  { title: "Data Collection Techniques", subheading: "Choosing the Right Methods for Reliable Data", content: "We assist in selecting the most effective data collection strategies tailored to your research objectives.", points: ["Choose between primary and secondary data collection.", "Design surveys, questionnaires, or interview guides.", "Ensure unbiased and ethical data collection.", "Select suitable sampling techniques.", "Address potential limitations in data gathering."] },
  { title: "Sampling Methods & Techniques", subheading: "Selecting the Right Participants for Your Study", content: "Our guidance ensures you pick the best sampling method for accurate and meaningful results.", points: ["Differentiate between probability and non-probability sampling.", "Determine the ideal sample size.", "Reduce bias in participant selection.", "Justify your sampling method in the methodology section.", "Align sampling with research objectives."] },
  { title: "Data Analysis & Interpretation", subheading: "Making Sense of Your Research Data", content: "We provide guidance on analyzing and interpreting data accurately to derive meaningful conclusions.", points: ["Choose appropriate data analysis methods.", "Use statistical or thematic analysis based on methodology.", "Interpret results effectively with supporting evidence.", "Visualize data with charts, graphs, and tables.", "Draw logical and valid conclusions."] },
  { title: "Validity, Reliability & Ethical Considerations", subheading: "Ensuring Credibility & Ethical Standards", content: "We guide you in maintaining high academic standards with ethical and reliable research practices.", points: ["Differentiate between validity and reliability.", "Use pilot studies to test research instruments.", "Follow ethical guidelines (informed consent, confidentiality).", "Minimize biases in data collection and analysis.", "Justify ethical considerations in your dissertation."] },
];

export default function DessertationGuidance() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 3,
        width: "100vw",
        minHeight: "100vh",
        overflow: "hidden",
        bgcolor: "#f5f5f5",
      }}
    >
      <Typography
        variant="h4"
        fontWeight={600}
        gutterBottom
        textAlign="center"
        color="#172554"
        sx={{ 
          fontSize: { xs: "22px", sm: "26px", md: "30px" },
          letterSpacing: "0.5px",
          mb: 3
        }}
      >
        Guidance{" "}
        <span
          style={{
            background:
              "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
            padding: "0px 5px",
            borderRadius: "4px"
          }}
        >
          for Research 
        </span>{" "}
        Excellence
      </Typography>
      
      {/* Main Content */}
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, width: "100%", flexGrow: 1, gap: 2 }}>
        {/* Left Sidebar - Headings */}
        <Box sx={{ 
          flex: 1, 
          backgroundColor: "#172554", 
          color: "white", 
          p: 2, 
          borderRadius: "8px", 
          display: "flex", 
          flexDirection: "column", 
          justifyContent: "center",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
        }}>
          <Typography 
            variant="h5" 
            fontWeight="bold" 
            textAlign="center" 
            mb={2}
            sx={{ 
              letterSpacing: "0.5px",
              textTransform: "uppercase"
            }}
          >
            Methodology Guidance
          </Typography>
          <List>
            {headings.map((item, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  selected={selectedIndex === index}
                  onClick={() => {
                    setSelectedIndex(index);
                    if (isSmallScreen) setOpen(true);
                  }}
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                    },
                    transition: 'background-color 0.3s ease'
                  }}
                >
                  <ListItemText 
                    primary={item.title} 
                    sx={{ 
                      color: "white", 
                      fontWeight: "bold",
                      '& .MuiTypography-root': {
                        fontWeight: 600,
                        letterSpacing: '0.5px'
                      }
                    }} 
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Right Content Section - Hidden in Small Screens */}
        {!isSmallScreen && (
          <Box sx={{ 
            flex: 2, 
            p: 3, 
            backgroundColor: "#f3f4f6", 
            color: "black", 
            borderRadius: "8px", 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
          }}>
            <motion.div 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }} 
              transition={{ duration: 0.5 }} 
              style={{ width: "100%" }}
            >
              <Box display="flex" justifyContent="center" alignItems="center">
                <Avatar src="logo22.png" sx={{ width: 80, height: 80, mb: 2 }} />
              </Box>

              <Typography 
                variant="h5" 
                fontWeight="bold" 
                textAlign="center" 
                mb={1}
                sx={{ 
                  letterSpacing: "0.5px",
                  color: "#172554"
                }}
              >
                {headings[selectedIndex].title}
              </Typography>
              <Typography 
                variant="subtitle1" 
                fontStyle="italic" 
                textAlign="center" 
                mb={2}
                sx={{ 
                  color: "#4a5568",
                  fontWeight: 500
                }}
              >
                {headings[selectedIndex].subheading}
              </Typography>
              <Typography 
                textAlign="justify" 
                mb={3}
                sx={{ 
                  lineHeight: 1.6,
                  color: "#2d3748"
                }}
              >
                {headings[selectedIndex].content}
              </Typography>
              <List sx={{ pl: { xs: 2, md: 4 }, width: "100%" }}>
                {headings[selectedIndex].points.map((point, i) => (
                  <ListItem 
                    key={i} 
                    sx={{ 
                      display: "list-item", 
                      mb: 1,
                      '& .MuiTypography-root': {
                        textAlign: 'justify',
                        lineHeight: 1.6
                      }
                    }}
                  >
                    <motion.div whileHover={{ scale: 1.05 }}>
                      <Typography>{point}</Typography>
                    </motion.div>
                  </ListItem>
                ))}
              </List>
            </motion.div>
          </Box>
        )}
      </Box>

      {/* Modal for Small Screens - IMPROVED LAYOUT */}
      <Modal 
        open={open} 
        onClose={() => setOpen(false)} 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center" 
        }}
      >
        <Box sx={{ 
          bgcolor: "white", 
          p: 3, 
          borderRadius: 2, 
          width: "90%", 
          maxWidth: "400px", 
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: 24, 
          position: "relative" 
        }}>
          {/* Close Button */}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ 
              position: "absolute", 
              top: 8, 
              right: 8, 
              color: "#000",
              zIndex: 10
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Modal Content */}
          <Box sx={{ pt: 3 }}>
            <Typography 
              variant="h5" 
              fontWeight="bold" 
              mb={1}
              sx={{ 
                letterSpacing: "0.5px",
                color: "#172554",
                textAlign: "center",
                pr: 4 // Add padding to prevent text from going under close button
              }}
            >
              {headings[selectedIndex].title}
            </Typography>
            <Typography 
              variant="subtitle1" 
              fontStyle="italic" 
              mb={2}
              sx={{ 
                color: "#4a5568",
                fontWeight: 500,
                textAlign: "center"
              }}
            >
              {headings[selectedIndex].subheading}
            </Typography>
            <Typography 
              mb={3}
              sx={{ 
                px: 1,
                lineHeight: 1.6,
                color: "#2d3748"
              }}
            >
              {headings[selectedIndex].content}
            </Typography>
            <Box sx={{ px: 1 }}>
              {headings[selectedIndex].points.map((point, i) => (
                <Box 
                  key={i} 
                  sx={{ 
                    display: "flex",
                    mb: 2,
                    alignItems: "flex-start"
                  }}
                >
                  <Box 
                    sx={{ 
                      minWidth: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      bgcolor: "#172554",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      mt: "2px",
                      fontSize: "14px",
                      fontWeight: "bold"
                    }}
                  >
                    {i+1}
                  </Box>
                  <Typography
                    sx={{
                      lineHeight: 1.5,
                      flex: 1
                    }}
                  >
                    {point}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}